import React, { Component } from 'react';
import splitImg from './images/split-line.png'
import './index.css';

export default class Split_line extends Component {
    render() {
        return (
            <div className='split-line'>
                <img src={splitImg} />
            </div>
        )
    }
}
